var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    fillOpacity: 0.58,
    d: "M20 1.875C20 .844 19.1 0 18 0H2C.9 0 0 .844 0 1.875v11.25C0 14.156.9 15 2 15h16c1.1 0 2-.844 2-1.875zm-2 0-8 4.688-8-4.688zm0 11.25H2V3.75l8 4.688 8-4.688z"
  })));
};
export default SvgMail;